import { MAP_ACTION_NAME_TO_ICON } from 'mobx/NotificationStore';

export const NOTIFICATION_TYPE = [
  {
    index: 0,
    type: 'mass_notification',
    text: 'ได้รับข้อความใหม่ :',
    icon: MAP_ACTION_NAME_TO_ICON.noti_mail(),
    reload: true,
  },
  { index: 1, type: 'report_comment', text: 'ข้อความตอบกลับ', icon: MAP_ACTION_NAME_TO_ICON.noti_mail(), reload: true },
  {
    index: 2,
    type: 'sos_comment',
    text: 'ข้อความตอบกลับ sos',
    icon: MAP_ACTION_NAME_TO_ICON.noti_mail(),
    reload: true,
  },
  {
    index: 3,
    type: 'report_incident',
    text: 'การแจ้งเหตุรายการใหม่ :',
    icon: MAP_ACTION_NAME_TO_ICON.noti_warning(),
    reload: true,
  },
  {
    index: 4,
    type: 'report_incident_transfer',
    text: 'การแจ้งเหตุรายการใหม่ (โอนงาน) :',
    icon: MAP_ACTION_NAME_TO_ICON.noti_warning(),
    reload: true,
  },
  {
    index: 5,
    type: 'update_report_status',
    text: 'Update Status',
    icon: MAP_ACTION_NAME_TO_ICON.noti_info_circle(),
    reload: true,
  },
  {
    index: 6,
    type: 'report_sos',
    text: 'ขอความช่วยเหลือ SOS',
    icon: MAP_ACTION_NAME_TO_ICON.noti_callsos(),
    reload: true,
  },
  {
    index: 7,
    type: 'report_sos_invite',
    text: 'ขอความช่วยเหลือ SOS',
    icon: MAP_ACTION_NAME_TO_ICON.noti_callsos(),
    reload: true,
  },
  {
    index: 8,
    type: 'report_sos_assignee',
    text: 'ขอความช่วยเหลือ SOS',
    icon: MAP_ACTION_NAME_TO_ICON.noti_callsos(),
    reload: true,
  },
  {
    index: 9,
    type: 'alarm_monitoring_scm',
    text: 'แจ้งเตือนสถานการณ์ฉุกเฉิน :',
    icon: MAP_ACTION_NAME_TO_ICON.noti_alarm(),
    reload: true,
  },
  {
    index: 10,
    type: 'alarm_monitoring_emergency',
    text: 'แจ้งเตือนสถานการณ์ฉุกเฉิน :',
    icon: MAP_ACTION_NAME_TO_ICON.noti_alarm(),
    reload: true,
  },
];

export const COLOR_NOTIFICATION_HIGHLIGHT = 'rgba(255, 55, 68, 1)';
